import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import { LoginPage } from './views';

export const routes: RouteObject[] = [
  { path: '/', element: <Navigate to="/login" replace /> },
  { path: '/login', element: <LoginPage/> },
];

export default routes;